export default "__VITE_ASSET__3455f579__"